<template>
  <div
    :class="['checkbox-animated', { active: selected }]"
    @click="$emit('checked')"
  >
    <input
      :id="`bundle_checkbox_${checkboxId}`"
      v-model="selected"
      type="checkbox"
      class="checkbox-animated__input bundle__checkbox"
      name="bundle_checkbox[]"
      :value="checkboxId"
    />
    <label
      :for="`bundle_checkbox_${checkboxId}`"
      class="checkbox-animated__label"
    >
      <svg width="20px" height="20px" rx="20" ry="20" viewBox="0 0 18 18">
        <path
          d="M1,9 L1,3.5 C1,2 2,1 3.5,1 L14.5,1 C16,1 17,2 17,3.5 L17,14.5 C17,16 16,17 14.5,17 L3.5,17 C2,17 1,16 1,14.5 L1,9 Z"
        ></path>
        <polyline points="3 7 7 12 14 6"></polyline>
      </svg>
    </label>
  </div>
</template>

<script>
export default {
  name: 'CheckboxAnimated',
  props: {
    selected: {
      type: Boolean,
      default: false,
    },
    checkboxId: {
      type: [Number, String],
      default: null,
    },
  },
}
</script>

<style lang="scss" scoped>
.checkbox-animated {
  display: flex;
  width: 35px;
  justify-content: flex-end;
  align-items: center;

  &:hover {
    cursor: pointer;
  }

  &.checkbox-animated--left {
    margin: 0;
    .checkbox-animated__label {
      margin: 0 5px 0 0;
    }
  }

  .checkbox-animated__label {
    cursor: pointer;
    position: relative;
    z-index: -1;
    margin: 0;
    display: block;
    width: 20px;
    height: 20px;
    -webkit-tap-highlight-color: transparent;
    transform: translate3d(0, 0, 0);

    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      z-index: -1;
      width: 20px;
      height: 20px;
      border-radius: 2px;
      background: none;
    }

    svg {
      position: relative;
      z-index: 1;
      fill: none;
      stroke-linecap: round;
      stroke-linejoin: round;
      stroke: #c8ccd4;
      stroke-width: 1.5;
      transform: translate3d(0, 0, 0);
      transition: all 0.2s ease ease-in-out;

      path {
        stroke-dasharray: 60;
        stroke-dashoffset: 0;
      }
      polyline {
        stroke: white;
        stroke-dasharray: 22;
        stroke-dashoffset: 66;
      }
    }

    &:hover::before {
      opacity: 1;
    }
    &:hover svg {
      stroke: $v4_color_primary;
    }
  }

  .checkbox-animated__input {
    display: none;
  }

  &.active .checkbox-animated__label {
    &::after {
      background: $v4_color_primary;
      transition: all 0.2s ease-in-out;
      transition-delay: 0.2s;
    }
    svg {
      stroke: $v4_color_primary;
    }
    path {
      stroke-dashoffset: 60;
      transition: all 0.3s ease-in-out;
    }
    polyline {
      stroke-dashoffset: 42;
      transition: all 0.2s ease-in-out;
      transition-delay: 0.27s;
      stroke: white;
    }
  }
}
</style>
